class UltraSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-ultra-slide]')];
    this.dots = [...this.querySelectorAll('[data-ultra-dot]')];
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

    this.querySelector('[data-ultra-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
    this.querySelector('[data-ultra-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onBlockSelect = (event) => {
    const selected = event.target.closest('[data-ultra-slide]');
    if (!selected || !this.contains(selected)) return;
    this.show(this.slides.indexOf(selected));
    this.stop();
  };

  start() {
    this.stop();
    if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
    const delay = Number(this.dataset.interval || 5) * 1000;
    this.timer = window.setInterval(() => this.show(this.index + 1), delay);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  show(nextIndex, restart = false) {
    if (!this.slides.length) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.index);
      dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
    });
    if (restart) this.start();
  }
}

if (!customElements.get('ultra-slideshow')) {
  customElements.define('ultra-slideshow', UltraSlideshow);
}
